import styles from './chess-order.module.scss';
import parse from 'html-react-parser';
import Image from 'next/image';
import {scrollToFormHandler} from '@helpers/scroll-to-form-handler.helper';
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";

type ChessOrderSectionProps = {
    section: {
        title: string,
        cards: [
            {
                title: string;
                description: string[];
                btnText: string;
                imageUrl: string;
            },
            {
                title: string;
                description: string[];
                btnText: string;
                imageUrl: string;
            },
            {
                title: string;
                description: string[];
                btnText: string;
                imageUrl: string;
            },
        ]
    }
    formId?: string;
}

const ChessOrderSection = ({section, formId}: ChessOrderSectionProps) => {
    return (
            <div className={`${styles.container}`}>
                <section className={styles.section}>
                    <div className={styles.section__head}>
                        <h2 className={styles.section__title}>{parse(section.title)}</h2>
                    </div>
                    <div className={styles.section__blocks}>
                        {section.cards.map((card, idx) => {
                            const isReversed: boolean = !!(idx % 2);
                            return (
                                <SharedAnimation key={card.title} render={(ref) => (
                                    <div ref={ref}
                                         className={`${animations.scroll__animation} ${styles.section__block} ${isReversed ? styles.reversed : ''}`}>
                                        <div className={styles.section__block_content}>
                                            <h3 className={styles.section__block_title}>{card.title}</h3>
                                            {(card.description ?? []).map((source, idx): JSX.Element => (
                                                <p key={idx} className={styles.section__text}>{source}</p>
                                            ))}
                                            {card.btnText && (
                                                <button onClick={(): void => scrollToFormHandler(formId ?? '')}
                                                        className={styles.section__link}>
                                                    <span>{card.btnText}</span>
                                                </button>)}
                                        </div>
                                        <div className={styles.section__image}>
                                            <Image src={card.imageUrl} alt={card.title} layout={'fill'} loading='eager'
                                                   objectFit={'contain'}/>
                                        </div>
                                    </div>
                                )}/>
                            )
                        })}
                    </div>
                </section>
            </div>
    )
}

export default ChessOrderSection;
